import { apiService } from "../services/api.service";

export const tovarController = {
    getTovarFoto,
    copyTableTovarFromSqlCloud
};

function getTovarFoto(idVariant, idKarta) {
    var url = "api/Tovar/GetTovarFoto?";

    if (idVariant) url = url + "idVariant=" + idVariant;
    else if (idKarta) url = url + "idKarta=" + idKarta;

    return apiService.fetchApiRequest(url);
}

function copyTableTovarFromSqlCloud() {
    return apiService.fetchApiRequest("api/Tovar/CopyTableTovarFromSqlCloud");
}



// WEBPACK FOOTER //
// ./src/controllers/tovar.controller.js